var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocusAreaWritingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_23297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4333 15.0333L24.9667 16.5667L9.86667 31.6667H8.33333V30.1333L23.4333 15.0333ZM29.4333 5C29.0167 5 28.5833 5.16667 28.2667 5.48333L25.2167 8.53333L31.4667 14.7833L34.5167 11.7333C35.1667 11.0833 35.1667 10.0333 34.5167 9.38333L30.6167 5.48333C30.2833 5.15 29.8667 5 29.4333 5ZM23.4333 10.3167L5 28.75V35H11.25L29.6833 16.5667L23.4333 10.3167Z",
    fill: "url(#paint0_linear_1433_23297)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_23297",
    x1: 4,
    y1: 6,
    x2: 36,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE59AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0439F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_23297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusAreaWritingIcon);
export default __webpack_public_path__ + "static/media/FocusAreaWritingIcon.6d48f635dd7e53209b1a6d9fff9dc028.svg";
export { ForwardRef as ReactComponent };